import { Platform, StatusBar, StyleSheet } from 'react-native';

import { COLOR } from 'utils/colors';
import {
    androidScreenMarginBottom,
    heightPercentageToDP,
    isTablet,
    isTabletOrWeb,
    widthPercentageToDP,
} from 'utils/responsiveness';

const MOBILE_TOP_PADDING = StatusBar.currentHeight || 20;

const styles = StyleSheet.create({
    dialog: {
        paddingTop: Platform.select({
            web: 0,
            ios: 0,
            default: isTablet
                ? 0
                : heightPercentageToDP(MOBILE_TOP_PADDING + 44),
        }),
        paddingHorizontal: 16,
        marginBottom: androidScreenMarginBottom,
    },
    button: { minWidth: isTabletOrWeb ? 120 : widthPercentageToDP(328) },
    closeSvg: {
        width: 16,
        height: 16,
    },
    description: {
        maxWidth: 724,
        marginTop: 8,
    },
    buttonText: {
        color: COLOR.BLACK,
    },
});

export default styles;
